import { useEffect } from 'react';
import * as CoreFns from '../utilities/CoreFns';
import NormalBtn from '../StockItems/NormalBtn';
import DropdownMenu from '../StockItems/DropdownMenu';

function App(props) {


  var currentList = props.currentList;
  var objPath = props.objPath;
  var organicChanges = props.organicChanges;
  var setItemEdited = props.setItemEdited;
  var userNos = props.userNos;

  useEffect(()=>{
    if (!currentList.cn){
      var changes = [{t:'w',w:['cn'],n:{}}];      
      organicChanges(changes);
    }

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!currentList.cn){
    return <div></div>
//
  }

  var currentNav = CoreFns.goDownPath(currentList, objPath);

  var navKeys = CoreFns.sortedKeyList(currentList.cn);

  var bottomBits = null;
  if (currentNav.on === 1){

    function setNavBarCommon(e){
      var uuid = CoreFns.uuidScoped(userNos, currentList, ['cn'], []); 
      var currentNavOut = JSON.parse(JSON.stringify(currentNav));
      delete currentNavOut.on;
      var n = {n:CoreFns.simplName(uuid), ord:0, nv:currentNavOut}
      var changes = [{t:'w', w:['cn', uuid], n}, {t:'w', w:objPath.concat(['on']),n:uuid}];
      organicChanges(changes);
    }

    bottomBits = <NormalBtn title='Transition: Set Nav Bar as Common Use' onClick={setNavBarCommon} icon='bx:wallet' backScreen={true} />
  }else{

    function deleteCommonUseBar(e){

      function doACheck(feOrPU){
        var pageKeys = Object.keys(currentList[feOrPU]);
        for (var i = 0; i < pageKeys.length; i++){
          if (objPath[0] === feOrPU && objPath[1] === pageKeys[i]){
          }else{
            var thisPage = currentList[feOrPU][pageKeys[i]];
            if (thisPage.nv && thisPage.nv.on === currentNav.on){
              window.alert('This Nav Bar is being used on ' + thisPage.n);
              return true;
            }
          }
        }
        return false;
      }

      var a = doACheck('fe');
      if (!a){
        var b = doACheck('pu');
        if (!b){
          setItemEdited(false);
          var changes = [{t:'w',w:objPath.concat(['on']),n:0}, {t:'r',w:['cn'],i:currentNav.on}];      
          organicChanges(changes);
        }
      }
    }

    var thisNav = currentList.cn[currentNav.on];

    function duplicateCommonUseBar(e){
      var newBit = JSON.parse(JSON.stringify(thisNav.nv));
      var uuid = CoreFns.uuidScoped(userNos, currentList, ['cn'], []); 
      var newName = thisNav.n + ' (Copy)';
      var newNav = {n:newName, ord:1, nv:newBit};
      var changes = [{t:'w', w:['cn', uuid], n:newNav}, {t:'w', w:objPath.concat(['on']), n:uuid}];
      organicChanges(changes);
    }

    function changeName(e){
      var thisNavName = thisNav.n;
      var p = window.prompt('New Name', thisNavName);
      if (p){
        var changes = [{t:'w', w:['cn', currentNav.on, 'n'], n:p}];
        organicChanges(changes);
      }

    }

    bottomBits = <center>

      <NormalBtn title='Delete this Nav Bar' onClick={deleteCommonUseBar} icon='fe:trash' backScreen={true} />
      <br/><br/>
      <NormalBtn title='Duplicate' onClick={duplicateCommonUseBar} icon='fa:copy' backScreen={true} />
      <br/><br/>
      <NormalBtn title={'Change Name'} onClick={changeName} icon='openmoji:european-name-badge' backScreen={true} />

      </center>
//
  }

  function setNavSource(newVal){
    if (newVal === 0){
      setItemEdited(false);
    }
    var changes = [{t:'w',w:objPath.concat(['on']),n:newVal}];      
    organicChanges(changes);
  }

  var commonNavs = navKeys.map((aNavKey, index)=>{
    return {n:currentList.cn[aNavKey].n, i:aNavKey};
  })

  var filterOptions = commonNavs.concat([{n:'No Nav Bar', i:0}]);
  if (currentNav.on === 1){
    filterOptions.push({n:'Page Nav Bar', i:1});
  }

  return (<td>
    <DropdownMenu clickItemInSelect={setNavSource} options={filterOptions} currentAnswer={currentNav.on}/>
    <br/>
    {bottomBits}
    </td>)
}
//
export default App;
